import { createReducer } from '@reduxjs/toolkit';
import {
  enqueueSnackbar,
  enqueueSnackbarList,
  removeSnackbar,
  closeSnackbar,
} from 'redux/actions/actions';
import { EnqueueSnackbarListAction } from 'redux/actions/type';
import { notificationInit } from 'redux/reducers/init';

const notification = createReducer(notificationInit, {
  [enqueueSnackbar.type]: (state, action) => {
    const { messages, options } = action.payload;
    const randomNumber = Math.random();
    const date = new Date().getTime();
    const key = date + randomNumber;
    state.notifications.push({
      key,
      messages,
      options,
      dismissed: false,
    });
  },
  [enqueueSnackbarList.type]: (state, action: EnqueueSnackbarListAction) => {
    const snackbarNotificationList = action.payload;

    snackbarNotificationList.forEach(notification => {
      const randomNumber = Math.random();
      const date = new Date().getTime();
      const key = date + randomNumber;
      state.notifications.push({
        key,
        messages: notification.messages,
        options: notification.options,
        dismissed: false,
      });
    });
  },
  [removeSnackbar.type]: (state, action) => {
    const { key } = action.payload;
    const { notifications } = state;
    state.notifications = notifications.filter(notification => notification.key !== key);
  },
  [closeSnackbar.type]: (state, action) => {},
});

export default notification;
